import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solicitud-actualizacion-credito',
  templateUrl: './solicitud-actualizacion-credito.component.html',
  styleUrls: ['./solicitud-actualizacion-credito.component.css']
})
export class SolicitudActualizacionCreditoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
